export const Dictionary = {
  __generic_api_failure: "Quelque chose s'est mal passé.",
  __generic_api_error: "Je ne peux pas répondre à votre demande maintenant.",
  __invalid_token:
    "Votre demande ne peut pas être complétée, le token n'est pas valide. Le token de sécurité est peut-être expiré ou a déjà été utilisé.",
  __generic_api_403: "Vous n'êtes pas autorisé à effectuer cette action.",
  __you_are_offline: "Vous n'êtes pas connecté à Internet.",
  __coming_soon:
    "Cette fonctionnalité est en cours de développement et sera disponible très prochainement.",
};
